const DEBUG_STORAGE_KEY = 'DEBUG';

const noop = () => {};

export function isClientDebugEnabled() {
  try {
    return localStorage.getItem(DEBUG_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

/**
 * Runtime console policy (no rebuild required).
 * - Off by default: console.log/debug/info/warn are no-ops; console.error remains.
 * - On: localStorage.setItem('DEBUG', 'true') then reload.
 *
 * Browser helpers (DevTools console):
 *   enableClientDebug()  — turn logs on
 *   disableClientDebug() — turn logs off
 */
export function applyConsoleDebugPolicy() {
  if (typeof window === 'undefined') {
    return;
  }

  window.enableClientDebug = () => {
    localStorage.setItem(DEBUG_STORAGE_KEY, 'true');
    window.location.reload();
  };

  window.disableClientDebug = () => {
    localStorage.removeItem(DEBUG_STORAGE_KEY);
    window.location.reload();
  };

  if (isClientDebugEnabled()) {
    return;
  }

  console.log = noop;
  console.debug = noop;
  console.info = noop;
  console.warn = noop;
}
